<div class="main-section">
    <div class="header">
        <h1>Advantage of Joining <span class="highlight">AlgoTutor</span></h1>
        <p>Transform Your Career with Industry's Most Comprehensive Learning Program</p>
    </div>

    <div class="content container">
        <div class="features">
            <div class="first-feature">
                <div class="feacture-content" *ngFor="let feature of firstfeatures">
                    <div class="icon">
                        <img src="{{feature.icon}}" alt="icon">
                    </div>
                    <div class="text-section">
                        <h4>{{feature.title}}</h4>
                        <P>{{feature.desc}}</P>
                    </div>
                </div>
            </div>
            <div class="first-feature">
                <div class="feacture-content" *ngFor="let feature of secondfeatures">
                    <div class="icon">
                        <img src="{{feature.icon}}" alt="icon">
                    </div>
                    <div class="text-section">
                        <h4>{{feature.title}}</h4>
                        <P>{{feature.desc}}</P>
                    </div>
                </div>
            </div>
            <div class="baner-imag">
                <img src="../../../assets/img/live-courses/advantage-banner.png" alt="banner">
            </div>
        </div>
        <div class="cta-section">
            <h2>Join AlgoTutor & Transform Your Career Today!</h2>
            <a href="{{link}}" target="_blank"><button class="cta-button">Register Now</button></a>

        </div>
    </div>


</div>